import { Component, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { MenuStore } from '../../../menus/service/menu.store';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { RouteUtils } from '../../utils/route-utils';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { EventUtils } from '../../utils/event-utils';
import { Party } from 'app/event/models/party';

@Component({
  selector: 'pioneer-overview-page',
  templateUrl: './overview-page.component.html'
})
export class OverviewPageComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public headerRecordType: SummaryRecordTypeEnum;

  public vendor: Party;

  constructor(private eventStore: EventStore,
              private menuStore: MenuStore,
              private route: ActivatedRoute,
              private authenticationSore: AuthenticationStore,
              private flashMessagesService: FlashMessagesService) {

  }

  ngOnInit() {
    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationSore.isAgencyUser()),
        this.onyxEvent.eventProperty.subscriber);
    }

    // If the event property is subscribed, reservations are retrieved to build the overview.
    // Otherwise, RSVPs are
    if (this.onyxEvent && this.onyxEvent.eventProperty.subscriber) {
      this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
    } else {
      this.headerRecordType = SummaryRecordTypeEnum.RSVP;
    }

    this.vendor = this.onyxEvent.eventProperty;

    // toggle page to editable if the URL ends with "edit" (it will default to read only)
    // otherwise, check if we need to show a warning flash message when in view modeFD
    RouteUtils.getLastUrlSegment(this.route)
      .subscribe(lastSegment => {
        if (this.authenticationSore.hasPermission('EditEvent') && !this.isEventValid()) {
          this.flashMessagesService.warn('EVENT.EVENT_MISSING_INFO',
            null,
            { hrefValue: `/#/event/${this.onyxEvent.eventId}/${this.vendor.eventPartyId}/summary/edit` });
        }
      });

  }

  isEventValid(): boolean {
    return EventUtils.isEventValid(this.onyxEvent, this.authenticationSore.isAgencyUser());
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/overview-page/overview-page.component.ts